import React from 'react';
import PropTypes from 'prop-types';

import { USD } from 'helpers/formatters/number_formats';
import { commissionModes } from './commission_modes';
import { formatDate } from 'helpers/formatters/date_time_formats';
import { getLeaseStructureAggregates } from './helpers/lease_structure';
import { round } from 'lodash';

class LeaseStructureTermsAggregates extends React.Component {
  static propTypes = {
    hideNotes: PropTypes.bool,
    includeOperatingExpenses: PropTypes.bool,
    leaseStructure: PropTypes.shape({
      commissionMode: PropTypes.oneOf(commissionModes).isRequired,
      leaseTerms: PropTypes.array.isRequired
    }).isRequired,
    showCommissionColumns: PropTypes.bool,
    showTransactionSides: PropTypes.bool,
  }

  getCommissionColumns(aggregates) {
    const commissionPercent = aggregates.commissionPercent == null
      ? null
      : `${round(aggregates.commissionPercent, 2)}%`;

    return (
      <React.Fragment>
        <td className="text-end">
          {commissionPercent}
        </td>
        <td className="text-end">
          {USD.format(aggregates.commissionAmount)}
        </td>
      </React.Fragment>
    );
  }

  getTransactionSideCommissionColumns(aggregates) {
    const buySideCommissionPercent = aggregates.buySideCommissionPercent == null
      ? null
      : `${round(aggregates.buySideCommissionPercent, 2)}%`;

    const sellSideCommissionPercent = aggregates.sellSideCommissionPercent == null
      ? null
      : `${round(aggregates.sellSideCommissionPercent, 2)}%`;

    return (
      <React.Fragment>
        <td className="text-end">
          {sellSideCommissionPercent}
        </td>
        <td className="text-end">
          {USD.format(aggregates.sellSideCommissionAmount)}
        </td>
        <td className="text-end">
          {buySideCommissionPercent}
        </td>
        <td className="text-end">
          {USD.format(aggregates.buySideCommissionAmount)}
        </td>
      </React.Fragment>
    );
  }

  render() {
    const {
      leaseStructure,
      showCommissionColumns,
      showTransactionSides,
      hideNotes,
    } = this.props;

    if (leaseStructure.leaseTerms.length === 0) {
      return null;
    }

    const aggregates = getLeaseStructureAggregates(leaseStructure);

    return (
      <tr className="text-nowrap">
        <td>
          {aggregates.startDate ? formatDate(aggregates.startDate) : null}
        </td>

        <td>
          {aggregates.endDate ? formatDate(aggregates.endDate) : null}
        </td>

        <td>
          {aggregates.months ? round(aggregates.months, 1) : ''}
        </td>

        {this.props.includeOperatingExpenses && <td/>}
        <td/>

        <td className="text-end">
          {USD.format(aggregates.leaseAmount)}
        </td>


        {showCommissionColumns && (
          showTransactionSides
            ? this.getTransactionSideCommissionColumns(aggregates)
            : this.getCommissionColumns(aggregates)
        )}

        {!hideNotes && <td/>}
        <td className="actions-column end-cell sticky-cell" />
      </tr>
    );
  }
}

export default LeaseStructureTermsAggregates;
